<template>
    <div>
        <div v-for="(error, index) in realErrors" v-bind:key="index">
            <div class="notification is-danger has-text-left" style="margin-bottom: 0.5em;">
                <button class="delete" title="Close notification" @click="closed(index)"></button>
                <span v-html="error"></span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ErrorNotifications",
        props: {
            errors: Array,
        },
        computed: {
            //Errors should be an array of strings, but sometimes things happen
            realErrors: function () {
                let newErrors = [];
                Array.prototype.forEach.call(this.errors, function (error) {
                    if(typeof(error) === 'string' || error instanceof String){
                        newErrors.push(error)
                    }
                    else if('object' == typeof error){
                        Array.prototype.forEach.call(error, (subError) => newErrors.push(subError));
                    }
                });
                return newErrors;
            }
        },
        methods: {
            'closed': function (index) {
                this.errors.splice(index);
                this.$emit('errors', this.errors);
            }
        }
    }
</script>

<style scoped>

</style>